module.exports = __webpack_public_path__ + "media/images/projects/6-logo-330944de22d99faee07d9f14e477f713.png";